import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTargetinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "none",
		fillRule: "evenodd",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 9
			}),
			/* @__PURE__ */ _jsx("path", { d: "M12 1v2m0 18v2m11-11h-2M3 12H1" })
		]
	})
});
export default SvgTargetinline;
